import { createSlice } from "@reduxjs/toolkit";
import _set from "lodash/set";

export type GlobalStateReducerState = Record<string, boolean>;

const initialState: GlobalStateReducerState = {};

export const globalStateSlice = createSlice({
  name: "globalStateReducers",
  initialState,
  reducers: {
    set: (state, action) => {
      const name = String(action.payload?.name) || "";
      state[name] = action.payload.param;
    },
    setField: (state, action) => {
      const name = String(action.payload?.name) || "";
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      _set(
        state,
        `${name}.${(action.payload?.field as string) || ""}`,
        action.payload?.value
      );
    },
    reset: (state, action) => {
      const name = String(action.payload?.name) || "";
      state[name] = {} as never;
    },
  },
});
